import React from "react";
import styles from "./landing.module.css";
import whatsappIcon from "../../assets/icons/whatsapp.svg";
import { WHATSAPP_URL } from "../../constants/whatsapp";

const WhatsAppFloatButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      className={styles.whatsapp_float}
      aria-label="Trade on WhatsApp"
    >
      <img src={whatsappIcon} alt="" width="28" height="28" />
      <span>Trade on WhatsApp</span>
    </a>
  );
};

export default WhatsAppFloatButton;
